<template>
  <div class="app-container">
    <el-form :model="search" :inline="true" label-position="right" ref="search">
      <el-form-item label="承运商名称" prop="partnerName">
        <el-input
          v-model="search.partnerName"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>

      <el-form-item label="组织编号" prop="partnershipId">
        <el-input
          v-model="search.partnershipId"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>

      <!-- <el-form-item label="风险评估" prop="field1">
        <el-select
          v-model="search.province"
          placeholder="请选择"
          clearable
          style="width: 100%"
        >
          <el-option
            v-for="item in optionList"
            :key="item.sfid"
            :label="item.sfen"
            :value="item.sfen"
            style="width: 100%"
          >
          </el-option>
        </el-select>
      </el-form-item> -->
    </el-form>
    <div class="row-bg">
      <el-button type="primary" size="medium" @click="goAdd"
        >添加承运商</el-button
      >
      <el-button type="primary" size="medium" @click="batchAddMasterFun"
        >批量添加承运商</el-button
      >
      <el-button type="primary" size="medium" @click="exportExcel()"
        >导出</el-button
      >
      <el-button type="primary" size="medium" @click="handleSearch()"
        >查询</el-button
      >
      <el-button size="medium" @click="resetForm">重置</el-button>
    </div>
    <el-table
      ref="checktableData"
      :data="list"
      v-loading="listLoading"
      :reserve-selection="true"
      center
      height="60vh"
    >
      <el-table-column
        label="组织编号"
        prop="partnershipId"
        width="80"
      ></el-table-column>
      <el-table-column
        label="承运商名称"
        prop="partnerName"
        width="180"
      ></el-table-column>
      <el-table-column label="组织类型" prop="" width="120">
        <template slot-scope="scope">{{
          partnershipTypeOption[scope.row.partnershipType]
        }}</template>
      </el-table-column>
      <el-table-column
        label="风险评估"
        prop="risk"
        width="120"
      ></el-table-column>
      <el-table-column
        label="承运中旧机数量"
        prop="carryOldMachineNum"
        width="120"
      ></el-table-column>
      <el-table-column label="保证金总额" prop="bondAmount" width="120">
        <template slot-scope="scope">{{
          scope.row.partnershipType !== 1 ? scope.row.bondAmount : "--"
        }}</template>
      </el-table-column>
      <el-table-column label="已占用保证金" prop="usedBondAmount" width="120">
        <template slot-scope="scope">{{
          scope.row.partnershipType !== 1 ? scope.row.usedBondAmount : "--"
        }}</template>
      </el-table-column>

      <el-table-column label="未占用保证金" prop="unuseBondAmount" width="120">
        <template slot-scope="scope">{{
          scope.row.partnershipType !== 1 ? scope.row.unuseBondAmount : "--"
        }}</template>
      </el-table-column>
      <el-table-column
        label="操作人"
        prop="createdName"
        width="120"
      ></el-table-column>
      <el-table-column label="创建时间" prop="createdDate" width="140">
        <template slot-scope="scope">{{
          scope.row.createdDate | formatDateTimeDefault
        }}</template>
      </el-table-column>

      <el-table-column label="操作" fixed="right" width="200" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="remove(scope.row)">移除</el-button>
          <el-button
            type="text"
            @click="goDetail(scope.row)"
            v-show="scope.row.partnershipType !== 1"
            >保证金管理</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="search.currPage"
        :page-size="search.pageSize"
        :page-sizes="[10, 20]"
        :total="total"
      >
      </el-pagination>
    </div>
    <addCarrierDialog
      ref="AddDialogRef"
      @opera-success="getList"
    ></addCarrierDialog>
    <commonBath
      ref="batchCommonRef"
      @opera-success="getList"
      :errUrl="'/autoapp-default-server-recovery/api/partnerManagementBond/downLoadFailInfo'"
      :downloadTemplateUrl="'/autoapp-default-server-recovery/api/partnerManagementBond/downLoadTemplate'"
      :importUrl="'/autoapp-default-server-recovery/api/partnerManagementBond/importPartnership'"
      :title="'批量添加承运商'"
      :uploadTitle="'导入承运商'"
    ></commonBath>

  </div>
</template>
<script>
import addCarrierDialog from "./components/addCarrierDialog";
// import BatchAddCarrier from "./components/BatchAddCarrier.vue";
import { getPartnerList, removePartnership } from "@/api/oldForNew";
import { orderStatusOption } from "./mixin.js";
import commonBath from "./components/commonBath.vue";

export default {
  name: "carrier",
  components: {
    addCarrierDialog,
    // BatchAddCarrier,
    commonBath
  },
  filters: {},

  data() {
    return {
      list: [],
      total: null, //列表总条数
      listLoading: false,
      createdTime: [], //开始时间
      optionList: [],
      orderStatusOption: orderStatusOption, //订单状态
      partnershipTypeOption: { 1: "子公司", 2: "合作商", 3: "总公司" }, //当前用户所属组织 1 子公司 2 第三方 3 总公司
      search: {
        partnerName: null,
        partnershipId: null,
        currPage: 1, //当前页
        pageSize: 10,
      },
    };
  },
  async created() {
    this.getList();
    // 获取当前账号的组织类型
    this.partnershipType = JSON.parse(localStorage.getItem("partnershipType"));
  },
  methods: {
    handleSearch(){
      this.search.currPage=1
      this.getList()
    },
    async getList() {
      let { statusCode, data, total, message } = await getPartnerList(
        this.search
      );
      if (statusCode == 200) {
        this.list = data || [];
        this.total = total || 0;
      } else {
        this.$message.error(message);
      }
    },
    resetForm() {
      this.search = this.$options.data().search;
    },
    //提交回收单
    goAdd(row) {
      this.$refs.AddDialogRef.openDialog(row, "edit");
    },
    handleSizeChange(val) {
      this.search.currPage = 1;
      this.search.pageSize = val;
      this.getList();
    },
    handleCurrentChange() {
      this.getList();
    },
    //取消回收单
    remove(row) {
      if (row.partnershipId) {
        if (row.usedBondAmount && row.partnershipType !== 1) {
          this.$message.warning("已占用保证金不为0，不可移除");
          return;
        }
        this.$dialog({
          title: "移除确认",
          content:
            "确认移除承运商，后续订单将不再分流给该承运商，不影响正在进行的单",
          cancel_buttton: "取消",
          ok_buttton: "确认",
          width: "400px",
          footBtn: "card",
          dialogType: "sighicon",
          onOk: () => {
            this.confirmRemove(row.partnershipId);
          },
          onCancel: () => {
            console.log("cancel");
          },
        });
      }
    },
    //确认移除
    async confirmRemove(partnershipId) {
      let { statusCode, data, message } = await removePartnership(
        partnershipId
      );
      if (statusCode == 200) {
        this.$message.success('移除成功');
        this.getList();
      } else {
        this.$message.error(message);
      }
      console.log("确认移除操作", data);
    },
    //批量添加承运商
    batchAddMasterFun() {
      this.$refs.batchCommonRef.openDialog();
    },
    //跳转到详情页
    goDetail(rowData) {
      this.$router.push({
        name: "/oldForNewService/carrierDetail", // 确保路由中有对应的name属性
        // params: {
        //   rowData: rowData,
        // },
        query: {
          id: rowData.partnershipId,
        },
      });
    },
    //导出
    exportExcel() {
      let url =
        "/autoapp-default-server-recovery/api/partnerManagementBond/export";
      let title = "承运商列表导出";

      let params = this.search;
      this.HttpService.post(url, params).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
        } else {
          this.$message.warning(res.message)
        }
      })
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.goodsStyle {
  display: flex;
  align-items: center;
}
.flex {
  display: flex;
  align-items: center;
  // margin: 0 20px;
  padding: 0 20px;
  span {
    min-width: 100px;
  }
}
.row-bg {
  margin-bottom: 15px;
}
.btnBox {
  margin-bottom: 20px;
}
.data-view-wrap {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-start;
  .item-wrap {
    margin-right: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #00b882;
    padding: 10px;
    height: auto;
    color: #fff;

    .unit {
      margin-left: 20px;
      max-width: 300px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      > span {
        font-size: 20px;
        padding-right: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/carrier.vue